import { createContext, useContext, useState } from "react";
import { api } from "../Assets/api/api";

export const AIConsumptionContext = createContext();

export const useAIConsumption = () => {
  return useContext(AIConsumptionContext);
};

export const AIConsumptionProvider = ({ children, user }) => {
  const [aiConsumption, setAiConsumption] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getAiConsumption = async () => {
    try {
      setIsLoading(true);
      const response = await api.get(`/api/ai-consumption${user.slug}`);
      setIsLoading(false);
      setAiConsumption(response.data.result);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  return (
    <AIConsumptionContext.Provider
      value={{ aiConsumption, isLoading, getAiConsumption }}
    >
      {children}
    </AIConsumptionContext.Provider>
  );
};
